import { render, staticRenderFns } from "./WsCuratorList.vue?vue&type=template&id=1f82ffb0&scoped=true"
import script from "./WsCuratorList.vue?vue&type=script&lang=js"
export * from "./WsCuratorList.vue?vue&type=script&lang=js"
import style0 from "./WsCuratorList.vue?vue&type=style&index=0&id=1f82ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82ffb0",
  null
  
)

export default component.exports